<template>
    <div class="lading-page">
        <div
            class="full-loading animate__animated animate__faster"
            v-show="loading"
            :class="{ animate__fadeIn: !loading }"
        >
            <eg-loading></eg-loading>
        </div>
        <div class="content animate__animated animate__fadeIn animate__faster" v-show="!loading">
            <template v-for="component in components">
                <component
                    :isMobile="isMobile"
                    :slugInfo="slugInfo"
                    :key="component"
                    :is="component"
                ></component>
            </template>
        </div>
    </div>
</template>

<script>
import { computed, reactive, toRefs } from '@vue/composition-api';
import { showToast } from '@/composibles/notification';
import { getSlug, getPhonesLocation } from '@/services/api';
import { setTitle, setPhones, setmainPhone } from '@/composibles/title-header';

import AutorityComponent from '@/components/landing-page/AutorityComponent';
import ConversionBanner from '@/components/landing-page/ConversionBanner';
import banner from '@/components/landing-page/banner';
import Gallery from '@/components/landing-page/gallery';
import LogosComponent from '@/components/landing-page/LogosComponent.vue';

export default {
    components: {
        AutorityComponent,
        ConversionBanner,
        banner,
        Gallery,
        LogosComponent,
    },
    metaInfo () {
        return {
            title: this.slugInfo.keyword ? this.slugInfo.keyword.name : 'Engelink',
        };
    },
    props: {
        isMobile: [Boolean, Object],
    },
    name: 'LandingPage',
    setup (_, { root }) {
        const self = reactive({
            loading: true,
            slugInfo: {},
            // colocar os componentes em ordem
            components: ['banner', 'Gallery', 'AutorityComponent', 'ConversionBanner', 'LogosComponent'],
        });

        const haveSlug = computed(() => {
            return !!self.slugInfo.slug.length;
        });

        const getPhonesNumber = async () => {
            const phones = await getPhonesLocation();
            const { phone } = phones.find((p) => p.mainPhone);
            setmainPhone(phone);
            setPhones(phones);
        };

        const getSlugCall = async () => {
            try {
                const data = await getSlug(root.$route.params.slug);
                self.slugInfo = data;
                if (!haveSlug.value) {
                    window.location = '/nova';
                }
                const title = self.slugInfo.keyword ? self.slugInfo.keyword.name : '';
                setTitle(title);
                self.loading = false;
            } catch (error) {
                console.log(error);
                showToast({
                    title: 'Erro interno em nossos servidores.',
                    text: 'Por favor tente mais tarde.',
                    icon: 'error',
                });
            }
        };

        getSlugCall();
        getPhonesNumber();
        return { ...toRefs(self) };
    },
};
</script>

<style lang="scss" scoped>
.lading-page {
    .full-loading {
        @apply w-full h-screen flex justify-center items-center bg-white;
    }
}
</style>
